import React, { useEffect, useContext } from 'react'
import { Col, Row, Card, CardHeader, CardBody, CardTitle } from 'reactstrap'
import ProductContext from 'context/product/productContext'
import ReactTable from 'react-table'
import ProductInfo from './ProductInfo'
import {
  submittedColumnHeaders,
  getSubmittedProductComponents,
  psScrollToTop,
} from './Utilities'

const BSProductsSubmitted = () => {
  const { getSubmittedBSProducts, products, saving, setSaving } = useContext(
    ProductContext
  )

  useEffect(() => {
    psScrollToTop()
    console.log('BSProductsSubmitted: ...loading')
    getSubmittedBSProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (saving) {
      psScrollToTop()
      getSubmittedBSProducts()
      setSaving(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saving])

  useEffect(() => {
    psScrollToTop()
  }, [products])

  // implementation for maximum of 1 row expanded at a time
  // const [expanded, setExpanded] = useState({})
  // const handleRowExpanded = (newExpanded, index) => {
  //   setExpanded({
  //     [index[0]]: !expanded[index[0]],
  //   })
  // }

  const getProductInfo = product => {
    console.log('product in getProductInfo is: ' + JSON.stringify(product))
    product.oldUPC = product.UPC
    const components = getSubmittedProductComponents(product)
    return <ProductInfo {...components} product={product} />
  }

  return (
    <div className="content">
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <CardTitle className="float-left" tag="h4">
                Brand Specific Products Pending - Reviewer 1
              </CardTitle>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={products ?? []}
                filterable
                columns={submittedColumnHeaders}
                defaultPageSize={10}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight primary-pagination"
                SubComponent={({ original }) => getProductInfo(original)}
                // implementation for maximum of 1 row expanded at a time
                // expanded={expanded}
                // onExpandedChange={(newExpanded, index) =>
                //   handleRowExpanded(newExpanded, index)
                // }
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default BSProductsSubmitted
